import { render, staticRenderFns } from "./DeviceReportServices.vue?vue&type=template&id=2c173c6d&scoped=true&"
import script from "./DeviceReportServices.vue?vue&type=script&lang=js&"
export * from "./DeviceReportServices.vue?vue&type=script&lang=js&"
import style0 from "./DeviceReportServices.vue?vue&type=style&index=0&id=2c173c6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c173c6d",
  null
  
)

export default component.exports